export enum HttpMimeType {
  PDF = 'application/pdf',
  JSON = 'application/json'
}
